<template>

    <div class="footer-container container-fluid">
        <div class="row">
            <div class="footer-headquarter col-12 col-md-6 offset-md-0 padding-y-80-80">
                <div class="row">
                    <div class="col-12 col-sm-10 offset-sm-1 offset-md-2">
                        <p class="mb-4 ff-sans fw-500 fz-40 color-black lh-xs">
                            Headquarters
                        </p>
                        <ul class="list-unstyled mb-0">
                            <li v-for="location in locations" class="mb-4">
                                <p class="mb-0 ff-sans fw-500 fz-16 color-black lh-xs" v-text="location.address"></p>
                                <p class="mb-0 ff-sans fw-500 fz-16 color-black lh-xs" v-text="location.city"></p>
                                <p class="mb-0 ff-sans fw-500 fz-16 color-black lh-xs"
                                   v-text="location.description"></p>
                            </li>
                        </ul>


                        <p class="ff-sans fw-500 fz-16 color-black lh-xs" v-text="info.headquarters"></p>
                        <div class="pt-5">
                            <div class="d-flex flex-row flex-nowrap">
                                <a :href="info.google_maps_link"
                                   target="_blank"
                                   rel="nofollow noopener"
                                   class="d-inline-block txt-no-underline ff-sans fw-500 fz-16-min-14 color-black color-black-hover text-uppercase lh-xs"
                                   style="padding-right: 5px !important"
                                   v-text="info.address"></a>
                                <span v-text="info.registered_office"
                                      class="d-inline-block ff-sans fw-500 fz-16-min-14 color-black color-black-hover lh-xs text-uppercase"></span>
                            </div>
                            <div class="mb-3 d-flex flex-row flex-nowrap">
                            <span
                                class="d-inline-block ff-sans fw-500 fz-16-min-14 color-black lh-xs text-uppercase">P.Iva </span>
                                <span v-text="info.vat_number"
                                      class="d-inline-block ff-sans fw-500 fz-16-min-14 color-black lh-xs text-uppercase"></span>
                            </div>
                            <div class="mb-3 d-flex flex-row flex-nowrap">
                            <span class="d-inline-block ff-sans fw-500 fz-16-min-14 color-black lh-xs text-uppercase"
                                  style="padding-right: 5px !important">
                                Phone -
                            </span>
                                <a :href="`tel:${info.phone}`" v-text="info.phone"
                                   class="d-inline-block ff-sans fw-500 fz-16-min-14 color-black color-white-hover lh-xs txt-no-underline text-uppercase"></a>
                            </div>
                            <ul id="list-members" class="list-unstyled mb-4">
                                <li v-for="member in members" class="list-members-item">
                                    <p v-text="member.name"
                                       class="mb-0 ff-sans fw-500 fz-16-min-14 color-black lh-xs"></p>
                                    <p v-text="member.title"
                                       class="mb-0 ff-sans fw-500 fz-16-min-14 color-black lh-xs text-uppercase"></p>
                                    <a :href="`mailto:${member.email}`" v-text="member.email"
                                       class="d-inline-block ff-sans fw-500 fz-16-min-14 color-black color-black-hover lh-xs txt-no-underline"></a>
                                </li>
                            </ul>

                            <!-- LA LISTA DEI SOCIAL, DATECI TUTTI GLI STILI CHE VOLETE, SPOSTATELA DOVE VI PARE IN QUESTO FILE -->
                            <!-- SE PERÒ VOLETE SPOSTARLA FUORI DA QUESTO FILE ALLORA CHIAMATEMI COSÌ VI DICO COSA FARE.-->
                            <!-- PERCHÈ OVVIAMENTE NON BASTA PRENDERE QUESTO PEZZO DI HTML E INFILARLO ALTROVE =) -->
                            <ul id="list-socials" class="list-unstyled mb-4">
                                <li v-for="social in socials" class="list-socials-item">
                                    <a :href="social.url" target="_blank">
                                        <i :class="social.icon"></i> lick social
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-about col-12 col-md-6 offset-md-0 padding-y-80-80">
                <div class="row d-flex justify-content-center">
                    <div class="col-12 col-sm-10 col-lg-8">
                        <p v-text="info.name"
                           class="ff-sans fw-500 fz-16 color-white lh-xs"></p>
                        <div v-html="info.about"
                             class="site-content link-white ff-sans fw-500 fz-16 color-white lh-xs"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row footer-info py-3 py-md-2">
            <div
                class="col-12 col-sm-10 offset-sm-1 d-flex flex-column flex-lg-row flex-lg-nowrap justify-content-lg-between">
                <div class="d-flex flex-column flex-md-row justify-content-md-between justify-content-lg-start">
                    <div class="d-flex flex-row flex-nowrap align-items-center">
                        &copy; <span v-text="info.name"
                                     class="ps-1 ff-sans fw-500 fz-14 color-black lh-xs text-uppercase"></span>
                    </div>
                    <div class="ps-md-3 ps-lg-4 d-flex flex-row flex-nowrap align-items-center">
                        <p class="pt-3 pt-md-0 mb-0 ff-sans fw-500 fz-14 color-black lh-xs text-uppercase">P.Iva</p>
                        <p v-text="info.fiscal_code"
                           class="ps-1 pt-3 pt-md-0 mb-0 ff-sans fw-500 fz-14 color-black lh-xs text-uppercase"></p>
                    </div>
                </div>
                <div
                    class="pt-md-3 pt-lg-0 d-flex flex-column flex-md-row justify-content-md-between justify-content-lg-start">

                    <Link href="cookie-policy"
                          class="ps-md-3 ps-lg-4 pt-3 pt-md-0 ff-sans fw-500 fz-14 color-black color-black-hover lh-xs txt-no-underline">
                        Cookie policy
                    </Link>
                    <a href="https://www.nexusweb.it/"
                       class="ps-md-3 ps-lg-4 pt-3 pt-md-0 ff-sans fw-500 fz-14 color-black color-black-hover lh-xs txt-no-underline"
                       target="_blank">
                        Powered by {n}exus
                    </a>

                </div>
            </div>
            <!--
             <div class="col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-0">
                <div class="row d-flex justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="d-flex flex-row flex-nowrap">
                            <a :href="info.google_maps_link"
                               target="_blank"
                               rel="nofollow noopener"
                               class="d-inline-block txt-no-underline ff-sans fw-500 fz-16-min-14 color-white color-white-hover text-uppercase lh-xs"
                               style="padding-right: 5px !important"
                               v-text="info.address"></a>
                            <span v-text="info.registered_office"
                                  class="d-inline-block ff-sans fw-500 fz-16-min-14 color-white color-white-hover lh-xs text-uppercase"></span>
                        </div>
                        <div class="mb-3 d-flex flex-row flex-nowrap">
                            <span
                                class="d-inline-block ff-sans fw-500 fz-16-min-14 color-white lh-xs text-uppercase">P.Iva </span>
                            <span v-text="info.vat_number"
                                  class="d-inline-block ff-sans fw-500 fz-16-min-14 color-white lh-xs text-uppercase"></span>
                        </div>
                        <div class="mb-3 d-flex flex-row flex-nowrap">
                            <span class="d-inline-block ff-sans fw-500 fz-16-min-14 color-white lh-xs text-uppercase"
                                  style="padding-right: 5px !important">
                                Phone -
                            </span>
                            <a :href="`tel:${info.phone}`" v-text="info.phone"
                               class="d-inline-block ff-sans fw-500 fz-16-min-14 color-white color-white-hover lh-xs txt-no-underline text-uppercase"></a>
                        </div>
                        <ul id="list-members" class="list-unstyled mb-4">
                            <li v-for="member in members" class="list-members-item  ">
                                <p v-text="member.name"
                                   class="mb-0 ff-sans fw-500 fz-16-min-14 color-white lh-xs"></p>
                                <p v-text="member.title"
                                   class="mb-0 ff-sans fw-500 fz-16-min-14 color-white lh-xs text-uppercase"></p>
                                <a :href="`mailto:${member.email}`" v-text="member.email"
                                   class="d-inline-block ff-sans fw-500 fz-16-min-14 color-white color-white-hover lh-xs txt-no-underline"></a>
                            </li>
                        </ul>
                        <div class="row">
                            <div class="col-6 col-sm-5 col-md-6 col-xl-5">
                                <Link href="/privacy"
                                      class="ff-sans fw-500 fz-16-min-14 color-white color-white-hover lh-xs txt-no-underline">
                                    Privacy policy
                                </Link>
                            </div>
                            <div class="col-6 col-sm-5 col-md-6 col-xl-5">
                                <Link href="/cookie"
                                      class="ff-sans fw-500 fz-16-min-14 color-white color-white-hover lh-xs txt-no-underline">
                                    Cookie policy
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             -->
        </div>
        <div class="d-none">
            <p v-text="info.business_name"></p>
            <p v-text="info.email"></p>
            <p v-text="info.fiscal_code"></p>
        </div>

    </div>

</template>

<script>
import {computed} from 'vue'
import {usePage} from '@inertiajs/inertia-vue3'

export default {
    name: "Footer",

    setup() {
        const info = computed(() => usePage().props.value.info)
        const members = computed(() => usePage().props.value.members);
        const locations = computed(() => usePage().props.value.locations);
        const socials = computed(() => usePage().props.value.socials);

        return {info, members, locations, socials}
    },

    mounted() {
    }
}
</script>

<style scoped>

</style>
